import React, { Children, useRef, useState } from 'react';
import ShowMore from './ShowMore';
import useGridColumns from './useGridColumns';
import './TileGrid.css';

/**
 * Baustein 5 — Tile-Grid.
 * Responsives Grid für `<DeckTile>` (auto-fill minmax 240px).
 *
 * Props:
 *   collapsedRows  — optional Number: kappt auf volle Reihen (columns × rows),
 *                    blendet Rest hinter automatischem <ShowMore>. Die Spaltenzahl
 *                    misst `useGridColumns` am gerenderten Grid (wie bei `CardGrid`) —
 *                    KEINE feste Item-Zahl angebbar (per Konstruktion viewport-sicher).
 *   showMoreLabel  — optional (hiddenCount, total) => string (default „Alle {total} anzeigen")
 */
export default function TileGrid({ className = '', collapsedRows, showMoreLabel, children }) {
  const ref = useRef(null);
  const columns = useGridColumns(ref);
  const [expanded, setExpanded] = useState(false);

  const items = Children.toArray(children);
  const collapse = collapsedRows != null && columns > 0 && !expanded;
  const visible = collapse ? items.slice(0, columns * collapsedRows) : items;
  const hidden = items.length - visible.length;

  const classes = ['tile-grid'];
  if (className) classes.push(className);

  return (
    <>
      <div className={classes.join(' ')} ref={ref}>{visible}</div>
      {hidden > 0 && (
        <ShowMore onClick={() => setExpanded(true)}>
          {showMoreLabel ? showMoreLabel(hidden, items.length) : `Alle ${items.length} anzeigen`}
        </ShowMore>
      )}
    </>
  );
}
